import React from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { Link } from 'react-router-dom'; // Import Link
import { useState, useEffect } from 'react';
import { useUserContext } from '../context/user_context';
import { API_BASE_URL } from '../utils/apiConfig';

//Pdf imports
import { FiDownload, FiPrinter } from 'react-icons/fi';
import { PDFDownloadLink } from '@react-pdf/renderer';
import Mypdf from '../components/PDF/Mypdf';

const formatDate = (dateString) => {

    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const formattedDate = new Date(dateString).toLocaleDateString(undefined, options);
    return formattedDate;
};

const GroupAccountWiseDataList = ({ items }) => {
    const {  user} = useUserContext();
    // for PDF generator
    const [pdfData, setPdfData] = useState(null);
    const [previewImageUrl, setPreviewImageUrl] = useState('');
    const userCompany = user?.results?.userCompany;
    const [companyName, setCompanyName] = useState(null);
       const [previewImage, setPreviewImage] = useState('https://github.com/OlgaKoplik/CodePen/blob/master/profile.jpg?raw=true');
       
        const [error, setError] = useState(null);

    const generateFileName = () => {
        const today = new Date();
        const date = today.getDate().toString().padStart(2, '0');
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const year = today.getFullYear();
        return `SubscriberGroupWise_Receivable_${year}-${month}-${date}.pdf`;
    };

    const fetchCompanyLogoUrl = async (logoKey) => {

        // setLoading(true);
        setError(null);

        try {
            // Fetch the signed URL for the company logo using a GET request
            const response = await fetch(`${API_BASE_URL}/get-signed-url?key=${encodeURIComponent(logoKey)}`, {
                method: 'GET',
                headers: {
                    // Include any headers if needed
                    // 'Authorization': 'Bearer YourAccessToken',
                },
            });

            if (response.ok) {
                const responseBody = await response.json();
                const signedUrl = responseBody.results;

                // setFormData({
                //     companyLogo: signedUrl,
                // })
                setPreviewImage(
                    signedUrl
                )


            } else {
                // Handle error if needed based on the HTTP status code
                console.error(`Failed to fetch signed URL for company logo: ${logoKey}`);
            }
        } catch (error) {
            // Handle fetch error
            console.error('Error fetching signed URL for company logo:', error);
            setError('Error fetching signed URL for company logo');
        } finally {
            //   setLoading(false);
        }
    };
    useEffect(() => {
        if (user.results.userCompany.length > 0) {

            if (user.results.userCompany[0].name) {
                setCompanyName(user.results.userCompany[0].name);
                fetchCompanyLogoUrl(user.results.userCompany[0].logo);
            }
        }
    }, [user]);
    const handleGeneratePDF = () => {

        const formattedData = items.map(item => ({
            auct_date: item.auct_date,
            total_supposed_to_pay: item.total_supposed_to_pay,
            total_paid_amount: item.total_paid_amount,
            total_outstanding_balance: item.total_outstanding_balance
        }));
        setPdfData(formattedData);
    };
    return (
        <div>
            {
                pdfData ? (
                    <PDFDownloadLink document={<Mypdf tableData={pdfData}
                        previewImageUrl={previewImageUrl}
                        tableHeaders={[
                            { title: "Auction Date", value: "auct_date" },
                            { title: "Total", value: "total_supposed_to_pay" },
                            { title: "Paid", value: "total_paid_amount" },
                            { title: "Due", value: "total_outstanding_balance" },
                        ]}
                        heading="Group AuctionWise Receivable" // Pass heading here
                        companyName={companyName}
                        companyData={userCompany}
                        base64Logo={previewImageUrl}
                    />} fileName={generateFileName()}>
                        {({ loading }) => (loading ? 'Loading document...' : <button onClick={() => {
                            setTimeout(() => {
                                setPdfData(null); // Reset pdfData after download
                            }, 500);
                        }}><FiDownload /> Download PDF</button>)}
                    </PDFDownloadLink>
                ) : (
                    <button onClick={handleGeneratePDF}><FiDownload /> Generate PDF</button>
                )
            }
            <div className='subcriber-list'>
                <article className='subcriber-header'>
                    <p>AuctDate</p>
                    <p>Total Amount</p>
                    <p>Paid</p>
                    <p>Outstanding</p>
                </article>
                {items?.map((item, index) => {
                    const { auct_date, id, total_supposed_to_pay, total_paid_amount, total_outstanding_balance } = item;
                    const formattedAuctionDate = formatDate(auct_date);

                    const formattedTotalPay = total_supposed_to_pay ?? 0;
                    const formattedPaid = total_paid_amount ?? 0;
                    const formattedOutstanding = total_outstanding_balance ?? 0;

                    return (
                        <article key={id} className='subcriber-data'>
                            <p>{formattedAuctionDate}</p>
                            <p>{formattedTotalPay}</p>
                            <p>{formattedPaid}</p>
                            <p>{formattedOutstanding}</p>
                        </article>
                    );
                })}
            </div>
        </div>
    );
};

export default GroupAccountWiseDataList;
